'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "error", "isHover", "isFocus", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Textarea } from "./Textarea.mjs";
import { textClass } from "../../styles/index.mjs";
/**
 * FormTextarea is a multi-line expandable text input, used within a form to capture long form text input.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formtextarea--docs) |
 * [Encore site](https://encore.spotify.net/web/components/form#form-text-area) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormTextarea) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-15525&t=ouXhP8WPuklpY62v-1)
 */
export var FormTextarea = /*#__PURE__*/React.forwardRef(function FormTextarea(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    error = _ref.error,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Textarea, Object.assign({
    ref: ref,
    className: cx(size === 'small' ? textClass('bodySmall') : textClass('bodyMedium'), className),
    "aria-invalid": error,
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $size: size,
    $isHover: isHover,
    $isFocus: isFocus,
    $error: error,
    "data-encore-id": ENCORE_DATA_IDS.FormTextarea
  }, props));
});